import React from 'react';
// Ana sayfamızda kullandığımız tüm component'leri buraya import ediyoruz
import HeroSlider from '../components/HeroSlider';
import Hakkimizda from '../components/Hakkimizda';
import Hizmetler from '../components/Hizmetler';
import Projeler from '../components/Projeler';
import Iletisim from '../components/Iletisim';
// Footer'ı buradan kaldırdık, çünkü App.js zaten koyuyor.

function Home() {
  return (
    // React Fragment (<></>) kullanarak birden fazla component'i grupluyoruz
    <>
      <HeroSlider />
      <Hakkimizda />
      <Hizmetler />
      <Projeler />
      <Iletisim />
      {/* Footer buradan silindi */}
    </>
  );
}

export default Home;